function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
import colors from '../theme/colors.js';
import Checkbox from "@mui/material/Checkbox";

/**
 * 
 * @param {*} props 
 */
const CheckboxStyled = props => {
  const style = {
    '&.MuiButtonBase-root:hover': {
      backgroundColor: colors.hoverGrey
    }
  };
  return /*#__PURE__*/React.createElement(Checkbox, _extends({
    sx: style
  }, props), props.children);
};
export default CheckboxStyled;